import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home/index",
  },
  {
    path: "/home",
    name: "home",
    component: HomeView,
    children: [
      {
        path: "index",
        component: () => import("../views/trunk/index.vue"),
      },
      {
        path: "product",
        component: () => import("../views/trunk/product.vue"),
      },
      {
        path: "serve",
        component: () => import("../views/trunk/serve.vue"),
      },
      {
        path: "liberalpay",
        component: () => import("../views/trunk/liberalpay.vue"),
      },
      {
        path: "contactUs",
        component: () => import("../views/trunk/contactUs.vue"),
      },
    ],
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../views/AboutView.vue"),
  },
  {
    path: "/customer",
    name: "customer",
    meta: { title: "  " },
    component: () => import("../views/customer/customer.vue"),
  },
  {
    path: "/agreement",
    name: "agreement",
    meta: { title: "服务协议" },
    component: () => import("../views/trunk/agreement.vue"),
  },
  {
    path: "/receiving",
    name: "receiving",
    meta: { title: "商户收款码申请" },
    component: () => import("../views/receiving/receiving.vue"),
  },

  // docsApi 文档

  {
    path: "/docsApi",
    redirect: "/docsApi/Description",
  },

  {
    path: "/docsApi",
    name: "docsApi",
    meta: { title: "开发文档" },

    component: () => import("../views/docsApi/docsApi.vue"),
    children: [
      {
        path: "Description",
        meta: { title: "开发文档" },
        component: () => import("../views/docsApi/order/Description.vue"),
        hidden: true,
      },
      {
        path: "orderPayment",
        meta: { title: "开发文档" },
        component: () => import("../views/docsApi/order/orderPayment.vue"),
      },
      {
        path: "orderInquiry",
        meta: { title: "开发文档" },
        component: () => import("../views/docsApi/order/orderInquiry.vue"),
      },
      {
        path: "orderRefund",
        meta: { title: "开发文档" },
        component: () => import("../views/docsApi/order/orderRefund.vue"),
      },
      {
        path: "orderRefundInquiry",
        meta: { title: "开发文档" },
        component: () =>
          import("../views/docsApi/order/orderRefundInquiry.vue"),
      },
      {
        path: "Cashier",
        meta: { title: "开发文档" },
        component: () => import("../views/docsApi/order/Cashier.vue"),
      },
      {
        path: "Asynchronous",
        meta: { title: "开发文档" },
        component: () => import("../views/docsApi/order/Asynchronous.vue"),
      },
      {
        path: "separateStep1",
        meta: { title: "开发文档" },
        component: () => import("../views/docsApi/separate/separateStep1.vue"),
      },
      {
        path: "separateStep2",
        meta: { title: "开发文档" },
        component: () => import("../views/docsApi/separate/separateStep2.vue"),
      },
      {
        path: "separateStep3",
        meta: { title: "开发文档" },
        component: () => import("../views/docsApi/separate/separateStep3.vue"),
      },
      {
        path: "separateStep4",
        meta: { title: "开发文档" },
        component: () => import("../views/docsApi/separate/separateStep4.vue"),
      },
      {
        path: "separateStep5",
        meta: { title: "开发文档" },
        component: () => import("../views/docsApi/separate/separateStep5.vue"),
      },
      {
        path: "separateStep6",
        meta: { title: "开发文档" },
        component: () => import("../views/docsApi/separate/separateStep6.vue"),
      },
            {
        path: "separateStep7",
        meta: { title: "开发文档" },
        component: () => import("../views/docsApi/separate/separateStep7.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }; // 将页面滚动到顶部
  },
});

export default router;
